<script>
    import {defaultEvmStores, signerAddress} from 'svelte-ethers-store'
    import {addEllipses} from "../utils";
    import {metaMaskExtensionInstallationLink} from "../constants/constants";

</script>
<div>
    <button class="simple-btn" on:click={() => {
        defaultEvmStores.setProvider().catch( () => {
           setTimeout(
                () =>
                  window.open(metaMaskExtensionInstallationLink, "_blank"),
                1000
           );
        })
    }}>
        {#if $signerAddress}
            {addEllipses($signerAddress)}
            {:else}
            Connect
        {/if}
    </button>
</div>

